<div class="toast z-50">
    <div
        class="bg-white flex justify-start gap-5 rounded-lg border-2"
        [ngClass]="{
            'border-iota-error': variant === 'error',
            'border-iota-warning': variant === 'warning',
            'border-iota-inh': variant === 'confirmation'
        }"
    >
        <div class="py-4 px-6 w-full items-center justify-between">
            <div class="flex items-center">
                <iota-icon [icon]="getFeedbackIcon()" [ngClass]="getFeedbackMessageColors()" class="rounded-full" size="1.5"></iota-icon>

                <p class="ml-2 font-bold text-iota-bg-darker">{{ header }}</p>
            </div>
            <div class="w-full flex justify-between items-center gap-3">
                <p class="ml-[32px] text-iota-bg-darker">
                    {{ message }} <span class="font-bold">{{ date }}</span>
                </p>
                <iota-icon
                    class="cursor-pointer min-w-[30px] text-iota-bg-darker"
                    icon="x-mark"
                    size="1.5"
                    (click)="onCloseMessageClick()"
                ></iota-icon>
            </div>
        </div>
    </div>
</div>
